import React,{Component} from 'react';
import Footer from '../../Home/Home_modules/Footerr/footer'
import './lottery.css'
import firebaseConfig from '../../fire';
import firebase from 'firebase/compat/app';

class LotteryPurchased extends Component{
    constructor(props){
        super(props);
        this.state = {
            lottery_id : '',
            total_tickets : '',
        }
    }
    componentWillMount(){
        const lottery_id = this.props.match.params.id;
        this.setState({lottery_id: lottery_id});
        const totalTickets = localStorage.getItem('totalTickets');
        this.setState({total_tickets: totalTickets});
        const lotteryRef = firebase
        .firestore()
        .collection("lottery") // Collection Name
        .doc(lottery_id); // Docment id
         lotteryRef.update({
            total_tickets: firebase.firestore.FieldValue.increment(totalTickets),
            total_players: firebase.firestore.FieldValue.increment(1)
          })
          .then(() => {
            console.log("Document updated"); // Document updated
          })
          .catch((error) => {
            console.error("Error updating doc", error);
          });	
    }
    render(){
        return(
            <>
            <div className="confirmation-container">
                <div className="confirmation-content">
                    <h3>Confirmation</h3>
                    <p>Your order for the purchase of <b>{this.state.total_tickets}</b> tickets has been confirmed!</p>
                    <button>Close</button>
                </div>
            </div>
            <Footer/>
            </>
        )
    }
}

export default LotteryPurchased;